
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);
import Home from '../views/Home.vue'
import Main from '../views/Main.vue'
import commonHome from '../views/commonHome/commonHome.vue'
import login from '@/views/Login/index.vue'

import venue from '../views/configurable/venue.vue'
import teacherInfo from '../views/configurable/teacherInfo.vue'
import teacherRest from '../views/configurable/teacherRest.vue'
//员工管理
import member from '../views/configurable/member.vue'
import buyTicket from '../views/buyTicket/buyTicket.vue'
import ticketType from '../views/buyTicket/ticketType.vue'

import backticket from '../views/buyTicket/backticket.vue'
import cards from '../views/cardModule/cards.vue'
import coach from '../views/coach/coach.vue'
import classList from '../views/coach/classList.vue'

import classType from '../views/classModule/classType.vue'
import classProject from '../views/classModule/classProject.vue'
import classTeacher from '../views/classModule/classTeacher.vue'

import siteList from '../views/siteModule/siteList.vue'
import siteListInfoList from '../views/siteModule/siteListInfoList.vue'
import gameList from '../views/gameModule/gameList.vue'
import gameIteminfo from '../views/gameModule/gameIteminfo.vue'
import dataSource from '../views/rootAdmin/dataSource.vue'
import addNode from '../views/rootAdmin/addNode.vue'
import addUser from '../views/rootAdmin/addUser.vue'
import note from '../views/rootAdmin/note.vue'
import menuList from '../views/rootAdmin/rootmenuList.vue'
import rootConfig from '@/views/rootAdmin/rootConfig'
import roleModule from '../views/rootAdmin/roleModule.vue'
import shopList from '@/views/configurable/shopList'
import configurable from '@/views/configurable/configurable'

//模板消息
import newConfig from '@/views/configurable/newConfig'
import newEmployeeConfig from '@/views/configurable/newEmployeeConfig'
import newMemberConfig from '@/views/configurable/newMemberConfig'
//场地预约
//siteYuyue
import siteYuyue from '../views/siteModule/siteYuyue.vue'
//热门推荐
import hotRecom from '../views/hotRecom/hotRecom.vue'
import hotInfo from '../views/hotRecom/hotInfo.vue'
//支付设置
import paySet from '../views/paySet/paySet.vue'
//退款记录
import refundMoney from '../views/refundMoney/refundMoney.vue'
export const constantRouterMap = [
    { 
        path: '/login', 
        name: 'login',
        component: login, 
        hidden: 'true'
    },
    { 
        path: '/404', 
        component:resolve => require(['../views/404.vue'], resolve), 
        hidden: 'true'
    },
    { 
        path: '/', 
        component:Home , 
        hidden: true,
        meta: {
            icon: 'el-icon-s-home',
            title:'首页',
        },
        children: [
            {   
                path: '/',
                component: commonHome,
                name: 'commonHome',
                meta: {
                    icon: 'el-icon-s-home',
                    title:'首页',
                },
                hidden: true
            },
        ]
    }
]
// _import('dashboard/index')
export const asyncRouterMap = [
    // {
    //     path: '',
    //     component: Home,
    //     name: 'Home',
    //     meta: {
    //         icon: 'el-icon-menu',
    //         title:'通用配置管理',
    //         roles: ['common']
    //     },
    //     hidden: false,
    //     children: [
    //         {   
    //             path: '/configurable/venue',
    //             component:venue,
    //             name: 'venue',
    //             meta: {
    //                 icon:'el-icon-user',
    //                 roles: ['common'],
    //                 title:'基础信息',
    //             },
    //             hidden: false
    //         },
    //         {   
    //             path: '/configurable/shopList',
    //             component:shopList,
    //             name: 'shopList',
    //             meta: {
    //                 roles: ['common'],
    //                 icon:'el-icon-s-shop',
    //                 title:'分店管理',
    //             },
    //             hidden: false
    //         },
    //         {   
    //             path: '/configurable/member',
    //             component:member,
    //             name: 'member',
    //             meta: {
    //                 roles: ['common'],
    //                 icon:'el-icon-s-custom',
    //                 title:'员工角色管理',
    //             },
    //             hidden: false
    //         },
    //         {   
    //             path: '/configurable/teacherInfo',
    //             component:teacherInfo,
    //             name: 'teacherInfo',
    //             meta: {
    //                 roles: ['common'],
    //                 icon:'el-icon-s-custom',
    //                 title:'教练信息',
    //             },
    //             hidden: false
    //         },
    //         {   
    //             path: '/configurable/teacherRest',
    //             component:teacherRest,
    //             name: 'teacherRest',
    //             meta: {
    //                 title:'休息设置',
    //                 roles: ['common'],
    //             },
    //             hidden: true
    //         },
            
    //         {   
    //             path: '/configurable/configurable',
    //             component:configurable,
    //             meta: {
    //                 roles: ['common'],
    //                 icon:'el-icon-picture',
    //                 title:'轮播图配置',
    //             },
    //             name: 'configurable',
    //             hidden: false
    //         },
    //         {   
    //             path: '/configurable/newConfig',
    //             component:newConfig,
    //             meta: {
    //                 roles: ['common'],
    //                 icon:'el-icon-s-tools',
    //                 title:'模板消息配置',
    //             },
    //             name: 'newConfig',
    //             hidden: false
    //         },
    //         {   
    //             path: '/configurable/newMemberConfig',
    //             component:newMemberConfig,
    //             meta: {
    //                 roles: ['common'],
    //                 icon:'el-icon-s-tools',
    //                 title:'消息推送员工配置',
    //             },
    //             name: 'newMemberConfig',
    //             hidden: false
    //         },
            
    //     ]
    // },
    // {   
    //     path: '',
    //     component: Home,
    //     name: 'ticket',
    //     meta: {
    //         icon:'el-icon-s-ticket',
    //         title: '票务管理',
    //         roles: ['common']
    //     },
    //     hidden: false,
    //     children:[
    //         {
    //             path: '/buyTicket/ticketType',
    //             meta: {
    //                 title: '票类型管理',
    //                 roles: ['common']
    //             },
    //             component:ticketType,
    //             name: 'ticketType',
    //             hidden: false,
    //         },
    //         {
    //             path: '/buyTicket/buyTicket',
    //             meta: {
    //                 title: '票管理',
    //                 roles: ['common']
    //             },
    //             component:buyTicket,
    //             name: 'buyTicket',
    //             hidden: false,
    //         },
    //         {
    //             path: '/buyTicket/backticket',
    //             meta: {
    //                 title: '退票管理',
    //                 roles: ['common']
    //             },
    //             component:backticket,
    //             name: 'backticket',
    //             hidden: true,
    //         },
    //     ]
    // },
    // // {   
    // //     path: '/backticket',
    // //     component: Home,
    // //     name: 'backticket',
    // //     // meta: { title: '首页导航', icon: 'table' },
    // //     meta: {
    // //         icon:'el-icon-setting',
    // //         title: '功能配置管理',
    // //         roles: ['common']
    // //     },
    // //     hidden: false,
    // //     children:[
    // // {
    // //     path: '/siteYuyue',
    // //     meta: {
    // //         roles: ['common']
    // //     },
    // //     component:Home,
    // //     hidden: false,
    // //     children:[
    // //         {
    // //             path: '/siteYuyue',
    // //             meta: {
    // //                 icon:'el-icon-s-home',
    // //                 title: '场地预约管理',
    // //                 roles: ['common']
    // //             },
    // //             component:siteYuyue,
    // //             name: 'siteYuyue',
    // //             hidden: false,
    // //         }
    // //     ]
    // // },


    // // {
    // //     path: '',
    // //     meta: {
    // //         roles: ['common']
    // //     },
    // //     component:Home,
    // //     name: 'card',
    // //     hidden: true,
    // //     children:[
    // //         {
    // //             path: '/cards',
    // //             meta: {
    // //                 icon:'el-icon-bank-card',
    // //                 title: '会员卡管理',
    // //                 roles: ['common']
    // //             },
    // //             component:cards,
    // //             name: 'cards'
    // //         }
    // //    ]
    // // },
    // {
    //     path: '',
    //     meta: {
    //         icon:'el-icon-school',
    //         title: '私教管理',
    //         roles: ['common']
    //     },
    //     component:Home,
    //     name: 'ptcource',
    //     hidden: false,
    //     children:[
    //         {
    //             path: '/coach/classList',
    //             meta: {
    //                 // icon:'el-icon-school',
    //                 title: '私教教室',
    //                 roles: ['common']
    //             },
    //             component:classList,
    //             name: 'classList',
    //             hidden: false
    //         },
    //         {
    //             path: '/coach/coach',
    //             meta: {
    //                 // icon:'el-icon-s-custom',
    //                 title: '私教管理',
    //                 roles: ['common']
    //             },
    //             component:coach,
    //             name: 'coach',
    //             hidden: false
    //         },
    //     ]
    // },
    // {
    //     path: '',
    //     meta: {
    //         title: '团课管理',
    //         icon:'el-icon-s-order',
    //         roles: ['common']
    //     },
    //     component:Home,
    //     name: 'tuanke',
    //     hidden: false,
    //     children:[
    //         {
    //             path: '/classModule/classType',
    //             meta: {
    //                 title: '团课类型管理',
    //                 roles: ['common']
    //             },
    //             component:classType,
    //             name: 'classType',
    //             hidden: false
    //         },
    //         {
    //             path: '/classModule/classProject',
    //             meta: {
    //                 // icon:'el-icon-document',
    //                 title: '团课项目管理',
    //                 roles: ['common']
    //             },
    //             component:classProject,
    //             name: 'classProject',
    //             hidden: false
    //         },
    //         {
    //             path: '/classModule/classTeacher',
    //             meta: {
    //                 // icon:'el-icon-edit-outline',
    //                 title: '排课管理',
    //                 roles: ['common']
    //             },
    //             component:classTeacher,
    //             name: 'classTeacher',
    //             hidden: false
    //         },
    //     ]
    // },
    
    
    // {
    //     path:'',
    //     component:Home,
    //     meta: {
    //         // icon:'el-icon-s-home',
    //         title: '场地管理',
    //         roles: ['common']
    //     },
    //     name:'place',
    //     hidden: false,
    //     children:[
    //         {
    //             path: '/siteModule/siteList',
    //             meta: {
    //                 icon:'el-icon-s-home',
    //                 title: '场地管理',
    //                 roles: ['common']
    //             },
    //             component:siteList,
    //             name: 'siteList',
    //             hidden: false
    //         },
            
            
    //     ]
    // },
    // {
    //     path:'',
    //     component:Home,
    //     meta: {
    //         roles: ['common']
    //     },
    //     hidden: true,
    //     children:[
    //         {
    //             path: '/siteModule/siteListInfoList',
    //             meta: {
    //                 title: '场地明细',
    //                 roles: ['common']
    //             },
    //             component:siteListInfoList,
    //             name: 'siteListInfoList',
    //             hidden: true
    //         },
    //     ]
    // },    
    // {
    //     path:'',
    //     component:Home,
    //     meta: {
    //         roles: ['common']
    //     },
    //     hidden: true,
    //     children:[
    //         {
    //             path: '/siteModule/siteYuyue',
    //             meta: {
    //                 icon:'el-icon-s-home',
    //                 title: '场地预约管理',
    //                 roles: ['common']
    //             },
    //             component:siteYuyue,
    //             name: 'siteYuyue',
    //             hidden: true
    //         },
    //     ]
    // },
    // {
    //     path: '',
    //     meta: {
    //         icon:'el-icon-s-data',
    //         roles: ['common']
    //     },
    //     component:Home,
    //     children:[
    //         {
    //             path: '/hotRecom/hotRecom',
    //             meta: {
    //                 icon:'el-icon-s-data',
    //                 title: '热门推荐',
    //                 roles: ['common']
    //             },
    //             component:hotRecom,
    //             name: 'hotRecom',
    //             hidden: false
    //         },
    //     ]
    // },
    // {
    //     path: '',
    //     meta: {
    //         icon:'el-icon-s-data',
    //         roles: ['common']
    //     },
    //     hidden: true,
    //     component:Home,
    //     children:[
    //         {
    //             path: '/hotRecom/hotInfo',
    //             meta: {
    //                 icon:'el-icon-s-data',
    //                 title: '热门推荐详情',
    //                 roles: ['common']
    //             },
    //             component:hotInfo,
    //             name: 'hotInfo',
    //         },
    //     ]
    // },
    // {
    //     path: '',
    //     meta: {
    //         roles: ['common']
    //     },
    //     component:Home,
    //     hidden: false,
    //     children:[
    //         {
    //             path: '/paySet/paySet',
    //             meta: {
    //                 icon:'el-icon-coin',
    //                 title: '支付设置',
    //                 roles: ['common']
    //             },
    //             component:paySet,
    //             name: 'paySet',
    //             hidden: false
    //         },
    //     ]
    // },
    // {
    //     path: '',
    //     meta: {
    //         roles: ['common']
    //     },
    //     name:'event',
    //     component:Home,
    //     hidden: false,
    //     children:[
    //         {
    //             path: '/gameModule/gameList',
    //             meta: {
    //                 icon:'el-icon-trophy',
    //                 title: '赛事管理',
    //                 roles: ['common']
    //             },
    //             component:gameList,
    //             name: 'gameList',
    //             hidden: false
    //     },
    //     ]
    // },
    // {
    //     path: '',
    //     meta: {
    //         roles: ['common']
    //     },
    //     component:Home,
    //     hidden: false,
    //     children:[
    //         {
    //             path: '/refundMoney/refundMoney',
    //             meta: {
    //                 icon:'el-icon-s-order',
    //                 title: '退款记录',
    //                 roles: ['common']
    //             },
    //             component:refundMoney,
    //             name: 'refundMoney',
    //             hidden: false
    //         },
    //     ]
    // },
    
    // {
    //     path: '',
    //     meta: {
    //         roles: ['common']
    //     },
    //     component:Home,
    //     hidden: true,
    //     children:[
    //         {
    //             path: '/gameModule/gameIteminfo',
    //             meta: {
    //                 icon:'el-icon-s-custom',
    //                 title: '赛事人员',
    //                 roles: ['common']
    //             },
    //             component:gameIteminfo,
    //             name: 'gameIteminfo',
    //             hidden: true
    //         },
    //     ]
    // },
        // ]
    // },
    
];
export const asyncRouterRootMap = [
    {   
        path: '',
        component: Home,
        meta: {
            icon:'el-icon-setting',
            title: '数据源模块',
            roles: ['root']
        },
        name: 'dataSource',
        hidden: false,
        children:[
            {
                path: '/rootAdmin/dataSource',
                meta: {
                    icon:'el-icon-s-data',
                    title: '数据源配置信息',
                    roles: ['root']
                },
                component:()=>import("@/views/rootAdmin/dataSource"),
                name: 'dataSource',
                hidden: false,
            },
            {
                path: '/paySet',
                meta: {
                    icon:'el-icon-coin',
                    title: '支付设置',
                    roles: ['root']
                },
                component: paySet,
                name: 'paySet',
                hidden: true
            },
            {
                path: '/rootConfig',
                meta: {
                    icon:'el-icon-s-operation',
                    title: '功能模块配置',
                    roles: ['root']
                },
                component:rootConfig,
                name: 'rootConfig',
                hidden: true,
                children:[]
            },
            {
                path: '/addNode',
                meta: {
                    icon:'el-icon-s-operation',
                    title: '功能节点',
                    roles: ['root']
                },
                component:addNode,
                name: 'addNode',
                hidden: false,
                children:[]
            },
            {
                path: '',
                meta: {
                    icon:'el-icon-s-tools',
                    title: '模板消息配置',
                    roles: ['root']
                },
                component: Main,
                name: 'newConfig',
                hidden: false,
                children:[
                  {
                    path: '/newConfig',
                    meta: {
                        title: '会员模板消息',
                        roles: ['root']
                    },
                    component:newConfig,
                    name: 'newConfig',
                    hidden: false,
                    children:[]
                  },
                  {
                    path: '/newEmployeeConfig',
                    meta: {
                        title: '员工模板消息',
                        roles: ['root']
                    },
                    component:newEmployeeConfig,
                    name: 'newEmployeeConfig',
                    hidden: false,
                    children:[]
                  },
                ]
            }
            // {
            //     path: '/roleModule',
            //     meta: {
            //         title: '角色管理',
            //         roles: ['root']
            //     },
            //     component:resolve => require(['../views/rootAdmin/roleModule.vue'], resolve),
            //     name: 'roleModule',
            //     hidden: false
            // },
            
        ]
    },
    {   
        path: '',
        component: Home,
        meta: {
            icon:'el-icon-user-solid',
            title: '用户角色管理',
            roles: ['root']
        },
        name: 'addUser',
        hidden: false,
        children:[
            {
                path: '/addUser',
                meta: {
                    icon:'el-icon-user-solid',
                    title: '用户管理',
                    roles: ['root']
                },
                component:addUser,
                name: 'addUser',
                hidden: false,
                children:[]
            },
            {
                path: '/roleModule',
                meta: {
                    icon:'el-icon-user',
                    title: '角色管理',
                    roles: ['root']
                },
                component:roleModule,
                name: 'roleModule',
                hidden: false,
                children:[]
            },
            
        ]
    },
    {
      path: '',
      component: Home,
      meta: {
          icon:'el-icon-message',
          title: '短信模块',
          roles: ['root']
      },
      name: 'note',
      hidden: false,
      children:[
          {
              path: '/note',
              meta: {
                  icon:'el-icon-message',
                  title: '短信管理',
                  roles: ['root']
              },
              component: note,
              name: 'note',
              hidden: false
          }
      ]
    },
    {
        path: '',
        component: Home,
        meta: {
            icon:'el-icon-s-grid',
            title: '菜单管理',
            roles: ['root']
        },
        hidden: false,
        children:[
            {
                path: '/rootAdmin/menuList',
                meta: {
                    icon:'el-icon-s-grid',
                    title: '菜单管理',
                    roles: ['root']
                },
                component: menuList,
                name: 'menuList',
                hidden: false
            }
        ]
    },
]
export default new Router({
    routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js